import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// --- META PIXEL INITIALIZATION ---
const initMetaPixel = () => {
  if (typeof window !== 'undefined') {
    const f = window as any;
    const b = document;
    const e = 'script';
    const v = 'https://connect.facebook.net/en_US/fbevents.js';
    if (f.fbq) return;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    s?.parentNode?.insertBefore(t, s);
    f.fbq('init', '1221158382812131');
    f.fbq('track', 'PageView');
  }
};
// Initialize Meta Pixel
initMetaPixel();
render(<App data-id="element-264" />, document.getElementById('root'));